module.exports = __webpack_public_path__ + "static/media/IMG_0068.db67f253.jpg";